"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoGoStartCommand = void 0;
const Command_1 = require("../Command");
const CommandType_1 = require("../lib/CommandType");
/**
 * Marks the start of the Go-Go Time mode for notes. Don will be dancing, bar
 * will be glowing, and marker will be burning during this mode. Score is
 * multiplied by 1.2 for all notes hit during this mode. Can be placed in the
 * middle of a measure.
 */
class GoGoStartCommand extends Command_1.Command {
    constructor() {
        super(CommandType_1.CommandType.GoGoStart);
    }
    static parse(_args) {
        return new GoGoStartCommand();
    }
}
exports.GoGoStartCommand = GoGoStartCommand;
